







import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DataSnapshot extends Vue {
  @Prop() dataToDisplay!: number | string;
  @Prop() captionToDisplay!: string;
}
